module.exports = __webpack_public_path__ + "af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/af.svg
// module id = 407
// module chunks = 0